module.exports = __webpack_public_path__ + "static/live-chat-ai-66c75b4a5fa0595b7ff68a58e794fdd6.webp";